// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--is-ltr .v-stepper--vertical .v-stepper__step__step{height:40px;font-weight:500;width:40px}.divider{border-bottom:hsla(0,0%,100%,.12)}.bold{font-weight:600}.date{font-weight:lighter;font-size:32px}.no-transition .v-stepper__wrapper{-webkit-transition-duration:50ms!important;transition-duration:50ms!important;-webkit-transition-timing-function:linear!important;transition-timing-function:linear!important}", ""]);
// Exports
module.exports = exports;
